<template>
  <span class="phone-watch" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
    <span class="phone-watch-btn">
      <icon type="iconic_phone"></icon>
      手机观看
    </span>

    <div class="phone-watch-popup-wrap" :style="{ display: show ? 'block' : 'none' }">
      <GuideToPhone
        class="phone-watch-hover-popup"
        :url="`${url}?chan=pc_web_video`"
      />
    </div>
  </span>
</template>

<script>
import GuideToPhone from '../guide-to-phone';

export default {
  data() {
    return {
      show: false,
    };
  },

  props: {
    url: String,
  },

  components: {
    GuideToPhone,
  },

  methods: {
    handleMouseEnter() {
      this.show = true;
      this.$emit('reportShow');
    },
    handleMouseLeave() {
      this.show = false;
    }
  },
};
</script>

<style lang="scss" scoped>
@import './style.scss';

.phone-watch {
  position: relative;
  &-btn {
    @include btn-style();
  }

  &-popup-wrap {
    position: absolute;
    z-index: 100;
    left: -18px;
    top: 30px;
    padding-top: 10px;
  }
}
</style>